import { useEffect } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import i18n from "utils/i18n";

import { FormField } from "components/Form";
import Input from "components/Input";
import { SelectComponent } from "components/Select";

export default function PersonalDetailsStep({
  languages,
}: {
  languages: { label: string; value: string; code: string }[];
}) {
  const { t } = useTranslation();

  const { control, watch } = useFormContext();
  const languageId = watch("languageId");

  useEffect(() => {
    i18n.changeLanguage(languages.find((lang) => lang.value === languageId)?.code);
  }, [languageId]);

  return (
    <>
      <FormField
        control={control}
        name="firstName"
        render={({ field }) => (
          <Input
            label={t("settings.companySettingsDialog.firstName")}
            placeholder={t("settings.companySettingsDialog.firstNamePlaceholder")}
            {...field}
          />
        )}
      />

      <FormField
        control={control}
        name="lastName"
        render={({ field }) => (
          <Input
            label={t("settings.companySettingsDialog.lastName")}
            placeholder={t("settings.companySettingsDialog.lastNamePlaceholder")}
            {...field}
          />
        )}
      />

      <FormField
        control={control}
        name="phone"
        render={({ field }) => (
          <Input
            label={t("settings.companySettingsDialog.phone")}
            placeholder={t("settings.companySettingsDialog.phonePlaceholder")}
            {...field}
          />
        )}
      />

      <FormField
        control={control}
        name="companyName"
        render={({ field }) => (
          <Input
            label={t("settings.companySettingsDialog.companyName")}
            placeholder={t("settings.companySettingsDialog.companyNamePlaceholder")}
            {...field}
          />
        )}
      />

      <FormField
        control={control}
        name="languageId"
        render={({ field }) => (
          <SelectComponent
            field={field}
            label={t("settings.companySettingsDialog.language")}
            options={languages}
            placeholder={t("settings.companySettingsDialog.languagePlaceholder")}
            description={t("settings.companySettingsDialog.languageChangeDescription")}
          />
        )}
      />
    </>
  );
}
